/*
================================================================================
 文件 3: src/App.js
 (作为应用的总路由，根据角色显示不同页面)
================================================================================
*/
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import LoginPage from './pages/LoginPage';
import WeatherLoginPage from './pages/WeatherLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import SalesDashboard from './pages/SalesDashboard';
import SharedDashboard from './pages/SharedDashboard';
import AccountingDashboard from './pages/AccountingDashboard';

const ROLES = { SUPER_ADMIN: 'SuperAdmin', ADMIN: 'Admin', SALES: 'Sales', RESIDENCE: 'Residence', ACCOUNTING: 'Accounting' };
const ROUTER_FUTURE_FLAGS = {
    v7_startTransition: true,
    v7_relativeSplatPath: true
};

function DashboardDispatcher() {
    const { user } = useAuth();

    switch (user.role) {
        case ROLES.SUPER_ADMIN:
        case ROLES.ADMIN:
            return <AdminDashboard />;
        case ROLES.SALES:
            return <SalesDashboard />;
        case ROLES.RESIDENCE:
            return <SharedDashboard />;
        case ROLES.ACCOUNTING:
            return <AccountingDashboard />;
        default:
            return <div>未知角色，无法访问系统。</div>;
    }
}

function AppRoutes() {
    const { user } = useAuth();

    if (!user) {
        return (
            <Routes>
                <Route path="/login-simple" element={<LoginPage />} />
                <Route path="*" element={<WeatherLoginPage />} />
            </Routes>
        );
    }

    return (
        <Routes>
            <Route path="/dashboard" element={<DashboardDispatcher />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <ToastProvider>
                <BrowserRouter future={ROUTER_FUTURE_FLAGS}>
                    <AppRoutes />
                </BrowserRouter>
            </ToastProvider>
        </AuthProvider>
    );
}
